export default "__VITE_ASSET__7270a205__"